@if (supervisorState) {
    @switch (supervisorState.subPhase) {
        @case (SupervisorSubPhase.WaitingForSupervisor) {
            <app-supervisor-panel
                [inverseColors]="true"
                [message]="'Insert supervisor RFID card to continue'"
                (backClicked)="cancelActionClicked.emit()"
                (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                [supervisorState]="supervisorState"
                [tableType]="tableType"
            />
        }

        @case (SupervisorSubPhase.ConfirmAction) {
            @switch (supervisorState.selectedAction) {
                @case (SupervisorAction.ContinueGame) {
                    <app-supervisor-panel
                        title="Continuing game"
                        i18n-title
                        message="Please confirm and insert croupier RFID card to continue game"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                        (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                        [supervisorState]="supervisorState"
                        [tableType]="tableType"
                    />
                }

                @case (SupervisorAction.VoidGame) {
                    <app-supervisor-panel
                        [title]="titleVoidGame"
                        message="Please confirm and insert croupier RFID card to continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                        (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                        [supervisorState]="supervisorState"
                        [tableType]="tableType"
                    />
                }

                @case (SupervisorAction.FreeHand) {
                    <app-supervisor-panel
                        [title]="titleFreeHand"
                        message="Please confirm and insert croupier RFID card to continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                        (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                        [supervisorState]="supervisorState"
                        [tableType]="tableType"
                    />
                }

                @case (SupervisorAction.ChangeResult) {
                    @if (supervisorState.changedGameResult) {
                        <app-supervisor-panel
                            title="Result changed"
                            i18n-title
                            message="Please confirm and insert croupier RFID card to continue"
                            i18n-message
                            (backClicked)="cancelActionClicked.emit()"
                            (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                            [supervisorState]="supervisorState"
                            [tableType]="tableType"
                        />
                    }
                }

                @case (SupervisorAction.CloseTable) {
                    <app-supervisor-panel
                        [title]="titleCloseTable"
                        message="Please confirm and insert croupier RFID card to continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                        (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                        [supervisorState]="supervisorState"
                        [tableType]="tableType"
                    />
                }
            }
        }

        @case (SupervisorSubPhase.ConfirmGameSelection) {
            <app-supervisor-panel
                [title]="titleConfirmGameSelection"
                message="Please confirm the selection and continue"
                i18n-message
                (backClicked)="cancelActionClicked.emit()"
                (confirmSupervisorAction)="confirmSupervisorAction.emit()"
                [supervisorState]="supervisorState"
                [tableType]="tableType"
            />
        }

        @case (SupervisorSubPhase.WaitingForCroupier) {
            <app-supervisor-panel
                title="Waiting for croupier"
                i18n-title
                message="Insert croupier RFID card to continue"
                i18n-message
                [showBackButton]="false"
                [supervisorState]="supervisorState"
                [tableType]="tableType"
            />
        }
    }
}
